import React, { useCallback, useEffect, useMemo, useState } from 'react';
import api from '../services/api'; // Certifique-se de que este caminho está correto no seu projeto

/* =============================================================
   Lumix Óticas — Fluxo de Caixa Clean
   Padrão visual: Google-like, DPI pequeno, grudado na tela.
   Multiempresa: usa API central + empresas dinâmicas.
============================================================= */

const STATUS_OPTIONS = [
  'Todos',
  'Pedido da lente',
  'Pedido realizado',
  'No laboratório',
  'Pronto na loja',
  'Entregue'
];

const METODO_META = {
  pix: { label: 'PIX', color: '#188038', bg: '#f1f8f4', border: '#cce8d5' },
  dinheiro: { label: 'Dinheiro', color: '#b06000', bg: '#fff7ed', border: '#fed7aa' },
  credito: { label: 'Crédito', color: '#1a73e8', bg: '#eef5ff', border: '#d2e3fc' },
  crédito: { label: 'Crédito', color: '#1a73e8', bg: '#eef5ff', border: '#d2e3fc' },
  debito: { label: 'Débito', color: '#7e22ce', bg: '#faf5ff', border: '#e9d5ff' },
  débito: { label: 'Débito', color: '#7e22ce', bg: '#faf5ff', border: '#e9d5ff' },
  outros: { label: 'Outros', color: '#5f6368', bg: '#f8fafd', border: '#dadce0' }
};

const Icons = {
  ArrowLeft: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="19" y1="12" x2="5" y2="12" />
      <polyline points="12 19 5 12 12 5" />
    </svg>
  ),
  Search: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  ),
  Refresh: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M21.5 2v6h-6" />
      <path d="M21.34 15.57a10 10 0 1 1-.59-9.21L21.5 8" />
    </svg>
  ),
  Close: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Cash: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="2" y="6" width="20" height="12" rx="2" />
      <circle cx="12" cy="12" r="3" />
      <path d="M6 10v4M18 10v4" />
    </svg>
  ),
  Wallet: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M20 7H5a3 3 0 0 1 0-6h12v4" />
      <path d="M3 5v14a3 3 0 0 0 3 3h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2Z" />
      <path d="M16 14h.01" />
    </svg>
  ),
  Alert: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  Building: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="4" y="2" width="16" height="20" rx="2" />
      <path d="M9 6h6M9 10h6M9 14h6M9 18h6" />
    </svg>
  ),
  Receipt: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2Z" />
      <path d="M8 7h8M8 12h8M8 17h5" />
    </svg>
  ),
  Chart: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M3 3v18h18" />
      <rect x="7" y="12" width="3" height="5" />
      <rect x="12" y="8" width="3" height="9" />
      <rect x="17" y="5" width="3" height="12" />
    </svg>
  )
};

/* =============================================================
   Helpers
============================================================= */

const formatCurrency = (value) =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(Number(value || 0));

const formatDateLocal = (dateString) => {
  if (!dateString) return '—';
  try {
    const datePart = String(dateString).split('T')[0];
    const [year, month, day] = datePart.split('-');
    if (!year || !month || !day) return new Date(dateString).toLocaleDateString('pt-BR');
    return `${day}/${month}/${year}`;
  } catch {
    return '—';
  }
};

const toInputDate = (dateString) => {
  if (!dateString) return '';
  try {
    return String(dateString).split('T')[0];
  } catch {
    return '';
  }
};

// CORREÇÃO 1: Procura por várias chaves comuns no localStorage
const safeParseUser = () => {
  try {
    const possiveisChaves = ['vizumUser', 'user', 'userData', 'auth_user', 'auth', 'usuario'];
    
    for (const key of possiveisChaves) {
      const stored = localStorage.getItem(key);
      if (stored) {
        const parsed = JSON.parse(stored);
        // Retorna o objeto do usuário, dependendo de como está aninhado
        return parsed?.user || parsed?.usuario || parsed || {};
      }
    }
    return {};
  } catch {
    return {};
  }
};

const getEmpresaIdFromUser = (user = {}) => {
  const raw =
    user?.empresaId?._id ||
    user?.empresaId ||
    user?.empresa?._id ||
    user?.empresa?.id ||
    user?.lojaId ||
    '';
  return raw ? String(raw) : '';
};

const montarParamsEmpresa = (empresaId) => {
  return empresaId ? { empresaId: String(empresaId) } : {};
};

// CORREÇÃO 2: Ampliado para pegar arrays aninhados em 'results', 'docs', etc.
const resolverArrayApi = (data, fallbackKey = '') => {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data?.docs)) return data.docs;
  if (fallbackKey && Array.isArray(data?.[fallbackKey])) return data[fallbackKey];
  if (Array.isArray(data?.empresas)) return data.empresas;
  if (Array.isArray(data?.ordens)) return data.ordens;
  if (Array.isArray(data?.ordensServico)) return data.ordensServico;
  return [];
};

const normalizarId = (value) => {
  if (!value) return '';
  if (typeof value === 'object') return String(value._id || value.id || '');
  return String(value);
};

const mesmoId = (a, b) => {
  if (!a || !b) return false;
  return String(a) === String(b);
};

const normalizarTexto = (value = '') =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

const getClienteNome = (os = {}) => {
  if (typeof os.cliente === 'string') return os.cliente;
  return os.cliente?.nome || os.cliente?.nomeCompleto || 'Cliente não informado';
};

const getClienteContato = (os = {}) => {
  return os.whatsapp || os.cliente?.telefone || os.cliente?.whatsapp || '—';
};

const getEmpresaIdOS = (os = {}) =>
  normalizarId(
    os.empresaId ||
      os.empresa?._id ||
      os.empresa?.id ||
      os.empresa ||
      ''
  );

const getEmpresaCodigo = (empresa = {}) =>
  String(empresa?.codigoLoja || empresa?.loja || empresa?._id || empresa?.id || '').trim();

const getEmpresaLabel = (empresa = {}) => {
  if (!empresa) return '';
  const nome = empresa.nome || empresa.razaoSocial || 'Empresa';
  const unidade = empresa.unidade && empresa.unidade !== 'Matriz' ? ` · ${empresa.unidade}` : '';
  return `${nome}${unidade}`;
};

const encontrarEmpresaDaOS = (os = {}, empresas = []) => {
  const osEmpresaId = getEmpresaIdOS(os);
  const loja = String(os.loja || '').trim();
  return (
    empresas.find((empresa) => {
      return (
        mesmoId(empresa._id, osEmpresaId) ||
        mesmoId(empresa.id, osEmpresaId) ||
        getEmpresaCodigo(empresa) === loja
      );
    }) || null
  );
};

const getLojaLabelOS = (os = {}, empresas = []) => {
  const empresa = encontrarEmpresaDaOS(os, empresas);
  return empresa ? getEmpresaLabel(empresa) : os.loja || 'Sem loja';
};

const getPagamentoMetodoKey = (metodo = '') => {
  const normalized = normalizarTexto(metodo);
  if (normalized.includes('pix')) return 'pix';
  if (normalized.includes('dinheiro')) return 'dinheiro';
  if (normalized.includes('credito')) return 'credito';
  if (normalized.includes('debito')) return 'debito';
  return normalized || 'outros';
};

const getMetodoMeta = (metodo = '') => {
  const key = getPagamentoMetodoKey(metodo);
  return METODO_META[key] || METODO_META.outros;
};

const getDataOS = (os = {}) => {
  return os.dataCompra || os.createdAt || os.data || os.dataEntrada || '';
};

const getPagamentos = (os = {}) => {
  return Array.isArray(os.pagamentos) ? os.pagamentos : [];
};

const getTotalPagoOS = (os = {}) => {
  return getPagamentos(os).reduce((acc, pg) => acc + (Number(pg.valor) || 0), 0);
};

const getValorTotalOS = (os = {}) => {
  const valorTotal = Number(os.valorTotal || 0);
  if (valorTotal > 0) return valorTotal;
  return getTotalPagoOS(os);
};

const getValorPendenteOS = (os = {}) => {
  const pendente = getValorTotalOS(os) - getTotalPagoOS(os);
  return pendente > 0.009 ? Number(pendente.toFixed(2)) : 0;
};

const getMonthStart = () => {
  const today = new Date();
  return new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0];
};

const getToday = () => new Date().toISOString().split('T')[0];

/* =============================================================
   Componentes pequenos
============================================================= */

function LoadingPanel() {
  return (
    <div className="fc-loading">
      <div className="thin-loader" />
      <span>Carregando fluxo de caixa...</span>
    </div>
  );
}

function KpiCell({ icon, label, value, help, tone = 'default' }) {
  return (
    <div className={`kpi-cell ${tone}`}>
      <div className="kpi-icon">{icon}</div>
      <span>{label}</span>
      <strong>{value}</strong>
      {help ? <small>{help}</small> : null}
    </div>
  );
}

function TabButton({ active, onClick, icon, children, count }) {
  return (
    <button type="button" className={`tab-clean ${active ? 'active' : ''}`} onClick={onClick}>
      {icon}
      <span>{children}</span>
      {typeof count === 'number' ? <i>{count}</i> : null}
    </button>
  );
}

function MetodoBadge({ metodo }) {
  const meta = getMetodoMeta(metodo);
  return (
    <span
      className="metodo-badge"
      style={{
        '--metodo-bg': meta.bg,
        '--metodo-color': meta.color,
        '--metodo-border': meta.border
      }}
    >
      {metodo || 'Outros'}
    </span>
  );
}

function MiniBar({ label, value, total, color = '#1a73e8' }) {
  const percent = total > 0 ? Math.min(100, Math.round((value / total) * 100)) : 0;
  return (
    <div className="mini-bar-row">
      <div className="mini-bar-top">
        <span>{label}</span>
        <strong>{formatCurrency(value)}</strong>
      </div>
      <div className="mini-bar-track">
        <i style={{ width: `${percent}%`, background: color }} />
      </div>
    </div>
  );
}

/* =============================================================
   Fluxo de Caixa
============================================================= */

// CORREÇÃO 3: Adicionado suporte a `customEmpresaId` direto na prop
export default function FluxoDeCaixa({ onOpenOS, onBack, customEmpresaId }) {
  const userLogado = useMemo(() => safeParseUser(), []);
  
  const empresaIdAtual = useMemo(() => {
    if (customEmpresaId) return String(customEmpresaId);
    return getEmpresaIdFromUser(userLogado);
  }, [userLogado, customEmpresaId]);

  const [ordens, setOrdens] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingEmpresas, setLoadingEmpresas] = useState(false);
  const [activeTab, setActiveTab] = useState('resumo');

  const [filters, setFilters] = useState({
    search: '',
    empresa: '',
    metodo: '',
    status: 'Todos',
    dataInicio: getMonthStart(), // Atenção: Se não houver ordens neste mês, vai aparecer zerado!
    dataFim: getToday()
  });

  const fetchEmpresas = useCallback(async () => {
    setLoadingEmpresas(true);
    try {
      const response = await api.get('/empresas', {
        params: {
          ...montarParamsEmpresa(empresaIdAtual),
          comResumo: true
        }
      });
      const dataResolvida = resolverArrayApi(response.data, 'empresas');
      console.log('[FluxoDeCaixa] Empresas carregadas:', dataResolvida);
      setEmpresas(dataResolvida.filter((empresa) => empresa.ativo !== false));
    } catch (error) {
      console.warn('[FluxoDeCaixa] Erro ao carregar empresas:', error);
      setEmpresas([]);
    } finally {
      setLoadingEmpresas(false);
    }
  }, [empresaIdAtual]);

  const fetchOrdens = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get('/ordens-servico', {
        params: montarParamsEmpresa(empresaIdAtual)
      });
      const dataResolvida = resolverArrayApi(response.data, 'ordens');
      console.log('[FluxoDeCaixa] OS carregadas:', dataResolvida);
      setOrdens(dataResolvida);
    } catch (error) {
      console.error('[FluxoDeCaixa] Erro ao carregar OS:', error);
      setOrdens([]);
    } finally {
      setLoading(false);
    }
  }, [empresaIdAtual]);

  useEffect(() => {
    fetchEmpresas();
    fetchOrdens();
  }, [fetchEmpresas, fetchOrdens]);

  const empresasFiltro = useMemo(() => {
    const lojasFallback = Array.from(
      new Set(
        ordens
          .map((os) => String(os.loja || '').trim())
          .filter(Boolean)
      )
    );

    if (empresas.length) {
      return empresas.map((empresa) => ({
        id: normalizarId(empresa._id || empresa.id),
        codigo: getEmpresaCodigo(empresa),
        label: getEmpresaLabel(empresa)
      }));
    }

    return lojasFallback.map((loja) => ({
      id: loja,
      codigo: loja,
      label: loja
    }));
  }, [empresas, ordens]);

  const metodosFiltro = useMemo(() => {
    const set = new Map();
    ordens.forEach((os) => {
      getPagamentos(os).forEach((pg) => {
        const metodo = pg.metodo || 'Outros';
        const key = getPagamentoMetodoKey(metodo);
        if (!set.has(key)) {
          set.set(key, metodo);
        }
      });
    });
    return Array.from(set.entries()).map(([key, label]) => ({
      key,
      label
    }));
  }, [ordens]);

  const baseFiltradaPorOS = useMemo(() => {
    const term = normalizarTexto(filters.search);

    return ordens.filter((os) => {
      if (filters.empresa) {
        const empresa = encontrarEmpresaDaOS(os, empresas);
        const osEmpresaId = getEmpresaIdOS(os);
        const loja = String(os.loja || '').trim();

        const matchEmpresa =
          mesmoId(osEmpresaId, filters.empresa) ||
          mesmoId(empresa?._id, filters.empresa) ||
          mesmoId(empresa?.id, filters.empresa);

        const matchCodigo =
          loja === filters.empresa ||
          getEmpresaCodigo(empresa || {}) === filters.empresa;

        if (!matchEmpresa && !matchCodigo) return false;
      }

      if (filters.status !== 'Todos' && os.status !== filters.status) return false;

      if (term) {
        const alvo = [
          getClienteNome(os),
          os.numeroOS,
          os.loja,
          getLojaLabelOS(os, empresas),
          os.vendedor,
          os.whatsapp
        ]
          .map(normalizarTexto)
          .join(' ');

        if (!alvo.includes(term)) return false;
      }

      return true;
    });
  }, [ordens, empresas, filters.empresa, filters.search, filters.status]);

  const stats = useMemo(() => {
    let totalRecebido = 0;
    let totalAVista = 0;
    let aReceberTotal = 0;
    let valorTotalVendido = 0;

    const entradas = [];
    const devedores = [];
    const porMetodo = {};
    const porEmpresa = {};

    baseFiltradaPorOS.forEach((os) => {
      const dataOS = toInputDate(getDataOS(os));
      const valorTotal = getValorTotalOS(os);
      const valorPago = getTotalPagoOS(os);
      const valorPendente = getValorPendenteOS(os);
      const lojaLabel = getLojaLabelOS(os, empresas);

      const osDentroPeriodo =
        (!filters.dataInicio || !dataOS || dataOS >= filters.dataInicio) &&
        (!filters.dataFim || !dataOS || dataOS <= filters.dataFim);

      if (osDentroPeriodo) {
        valorTotalVendido += valorTotal;

        if (valorPendente > 0.009) {
          aReceberTotal += valorPendente;
          devedores.push({
            id: os._id,
            os: os.numeroOS,
            cliente: getClienteNome(os),
            contato: getClienteContato(os),
            loja: lojaLabel,
            data: getDataOS(os),
            valorTotal,
            valorPago,
            valorPendente,
            status: os.status
          });
        }
      }

      getPagamentos(os).forEach((pg) => {
        const dataPagamento = toInputDate(pg.data || os.createdAt || os.dataCompra);

        if (filters.dataInicio && dataPagamento && dataPagamento < filters.dataInicio) return;
        if (filters.dataFim && dataPagamento && dataPagamento > filters.dataFim) return;

        const metodo = pg.metodo || 'Outros';
        const metodoKey = getPagamentoMetodoKey(metodo);

        if (filters.metodo && metodoKey !== filters.metodo) return;

        const valor = Number(pg.valor || 0);

        if (valor <= 0) return;

        totalRecebido += valor;

        if (metodoKey === 'dinheiro' || metodoKey === 'pix' || metodoKey === 'debito') {
          totalAVista += valor;
        }

        porMetodo[metodoKey] = porMetodo[metodoKey] || {
          key: metodoKey,
          label: metodo,
          valor: 0,
          quantidade: 0
        };

        porMetodo[metodoKey].valor += valor;
        porMetodo[metodoKey].quantidade += 1;

        porEmpresa[lojaLabel] = porEmpresa[lojaLabel] || {
          label: lojaLabel,
          valor: 0,
          quantidade: 0
        };

        porEmpresa[lojaLabel].valor += valor;
        porEmpresa[lojaLabel].quantidade += 1;

        entradas.push({
          id: `${os._id}-${pg._id || pg.id || entradas.length}`,
          osId: os._id,
          os: os.numeroOS,
          cliente: getClienteNome(os),
          loja: lojaLabel,
          data: pg.data || os.createdAt || os.dataCompra,
          metodo,
          metodoKey,
          parcelas: Number(pg.parcelas || 1),
          valor,
          status: os.status
        });
      });
    });

    const ticketMedio = entradas.length ? totalRecebido / entradas.length : 0;

    return {
      totalRecebido,
      totalAVista,
      aReceberTotal,
      valorTotalVendido,
      ticketMedio,
      qtdEntradas: entradas.length,
      qtdDevedores: devedores.length,
      entradas: entradas.sort((a, b) => new Date(b.data || 0) - new Date(a.data || 0)),
      devedores: devedores.sort((a, b) => b.valorPendente - a.valorPendente),
      metodos: Object.values(porMetodo).sort((a, b) => b.valor - a.valor),
      empresas: Object.values(porEmpresa).sort((a, b) => b.valor - a.valor)
    };
  }, [baseFiltradaPorOS, empresas, filters.dataInicio, filters.dataFim, filters.metodo]);

  const limparFiltros = () => {
    setFilters({
      search: '',
      empresa: '',
      metodo: '',
      status: 'Todos',
      dataInicio: '',
      dataFim: ''
    });
  };

  const aplicarMesAtual = () => {
    setFilters((prev) => ({
      ...prev,
      dataInicio: getMonthStart(),
      dataFim: getToday()
    }));
  };

  const abrirOS = (osId) => {
    if (!osId || !onOpenOS) return;
    onOpenOS(osId);
  };

  return (
    <div className="fc-page">
      <GlobalStyles />

      <header className="fc-top">
        <div className="fc-top-left">
          {onBack ? (
            <button type="button" className="plain-btn" onClick={onBack}>
              <Icons.ArrowLeft />
              Voltar
            </button>
          ) : null}

          <div>
            <span className="kicker">Lumix Óticas</span>
            <h1>Fluxo de caixa</h1>
            <p>Entradas, pendências e distribuição financeira por ótica.</p>
          </div>
        </div>

        <div className="fc-actions">
          <button type="button" className="plain-icon-btn" onClick={fetchOrdens} title="Atualizar">
            <Icons.Refresh />
          </button>
        </div>
      </header>

      <section className="filter-shell">
        <div className="search-box">
          <Icons.Search />
          <input
            value={filters.search}
            onChange={(e) => setFilters((prev) => ({ ...prev, search: e.target.value }))}
            placeholder="Buscar cliente, OS, loja, vendedor..."
          />
        </div>

        <select
          value={filters.empresa}
          onChange={(e) => setFilters((prev) => ({ ...prev, empresa: e.target.value }))}
          disabled={loadingEmpresas}
        >
          <option value="">{loadingEmpresas ? 'Carregando óticas...' : 'Todas as óticas'}</option>
          {empresasFiltro.map((empresa) => (
            <option key={empresa.id || empresa.codigo} value={empresa.id || empresa.codigo}>
              {empresa.label}
            </option>
          ))}
        </select>

        <select
          value={filters.metodo}
          onChange={(e) => setFilters((prev) => ({ ...prev, metodo: e.target.value }))}
        >
          <option value="">Todos os métodos</option>
          {metodosFiltro.map((metodo) => (
            <option key={metodo.key} value={metodo.key}>
              {metodo.label}
            </option>
          ))}
        </select>

        <select
          value={filters.status}
          onChange={(e) => setFilters((prev) => ({ ...prev, status: e.target.value }))}
        >
          {STATUS_OPTIONS.map((status) => (
            <option key={status} value={status}>
              {status === 'Todos' ? 'Todos os status' : status}
            </option>
          ))}
        </select>

        <input
          type="date"
          value={filters.dataInicio}
          onChange={(e) => setFilters((prev) => ({ ...prev, dataInicio: e.target.value }))}
        />

        <input
          type="date"
          value={filters.dataFim}
          onChange={(e) => setFilters((prev) => ({ ...prev, dataFim: e.target.value }))}
        />

        <button type="button" className="plain-btn month-btn" onClick={aplicarMesAtual}>
          Mês atual
        </button>

        <button type="button" className="plain-icon-btn" onClick={limparFiltros} title="Limpar filtros">
          <Icons.Close />
        </button>
      </section>

      {loading ? (
        <LoadingPanel />
      ) : (
        <>
          <section className="kpi-strip">
            <KpiCell
              icon={<Icons.Cash />}
              label="Recebido"
              value={formatCurrency(stats.totalRecebido)}
              help={`${stats.qtdEntradas} entrada(s)`}
              tone="green"
            />

            <KpiCell
              icon={<Icons.Alert />}
              label="A receber"
              value={formatCurrency(stats.aReceberTotal)}
              help={`${stats.qtdDevedores} cliente(s) pendente(s)`}
              tone="orange"
            />

            <KpiCell
              icon={<Icons.Receipt />}
              label="Vendido"
              value={formatCurrency(stats.valorTotalVendido)}
              help="OS no período"
              tone="blue"
            />

            <KpiCell
              icon={<Icons.Wallet />}
              label="Ticket médio"
              value={formatCurrency(stats.ticketMedio)}
              help="Por recebimento"
              tone="neutral"
            />

            <KpiCell
              icon={<Icons.Chart />}
              label="Recebido à vista"
              value={formatCurrency(stats.totalAVista)}
              help="Pix, dinheiro e débito"
              tone="neutral"
            />
          </section>

          <section className="tabs-line">
            <TabButton
              active={activeTab === 'resumo'}
              onClick={() => setActiveTab('resumo')}
              icon={<Icons.Chart />}
            >
              Resumo
            </TabButton>

            <TabButton
              active={activeTab === 'entradas'}
              onClick={() => setActiveTab('entradas')}
              icon={<Icons.Cash />}
              count={stats.entradas.length}
            >
              Entradas
            </TabButton>

            <TabButton
              active={activeTab === 'areceber'}
              onClick={() => setActiveTab('areceber')}
              icon={<Icons.Alert />}
              count={stats.devedores.length}
            >
              A receber
            </TabButton>
          </section>

          {activeTab === 'resumo' ? (
            <ResumoClean stats={stats} />
          ) : null}

          {activeTab === 'entradas' ? (
            <EntradasTable lista={stats.entradas} onOpenOS={abrirOS} />
          ) : null}

          {activeTab === 'areceber' ? (
            <AReceberTable lista={stats.devedores} onOpenOS={abrirOS} />
          ) : null}
        </>
      )}
    </div>
  );
}

/* =============================================================
   Abas
============================================================= */

function ResumoClean({ stats }) {
  const maiorMetodo = stats.metodos[0]?.valor || 0;
  const maiorEmpresa = stats.empresas[0]?.valor || 0;

  return (
    <main className="summary-grid">
      <section className="flat-panel">
        <div className="panel-head">
          <div>
            <h2>Métodos de pagamento</h2>
            <p>Distribuição das entradas no período.</p>
          </div>
        </div>

        {stats.metodos.length ? (
          <div className="bar-list">
            {stats.metodos.map((item) => {
              const meta = getMetodoMeta(item.label);
              return (
                <MiniBar
                  key={item.key}
                  label={`${item.label} · ${item.quantidade}x`}
                  value={item.valor}
                  total={maiorMetodo}
                  color={meta.color}
                />
              );
            })}
          </div>
        ) : (
          <div className="empty-state">Nenhuma entrada registrada para os filtros.</div>
        )}
      </section>

      <section className="flat-panel">
        <div className="panel-head">
          <div>
            <h2>Entradas por ótica</h2>
            <p>Quanto cada unidade recebeu no caixa.</p>
          </div>
        </div>

        {stats.empresas.length ? (
          <div className="bar-list">
            {stats.empresas.map((item) => (
              <MiniBar
                key={item.label}
                label={`${item.label} · ${item.quantidade}x`}
                value={item.valor}
                total={maiorEmpresa}
                color="#1a73e8"
              />
            ))}
          </div>
        ) : (
          <div className="empty-state">Nenhuma ótica com entrada no período.</div>
        )}
      </section>

      <section className="flat-panel full">
        <div className="panel-head">
          <div>
            <h2>Leitura rápida</h2>
            <p>Resumo operacional do caixa.</p>
          </div>
        </div>

        <div className="read-grid">
          <div>
            <span>Entrada total</span>
            <strong>{formatCurrency(stats.totalRecebido)}</strong>
          </div>
          <div>
            <span>Saldo pendente</span>
            <strong>{formatCurrency(stats.aReceberTotal)}</strong>
          </div>
          <div>
            <span>Transações</span>
            <strong>{stats.qtdEntradas}</strong>
          </div>
          <div>
            <span>Clientes pendentes</span>
            <strong>{stats.qtdDevedores}</strong>
          </div>
        </div>
      </section>
    </main>
  );
}

function EntradasTable({ lista, onOpenOS }) {
  return (
    <section className="table-panel">
      <div className="panel-head">
        <div>
          <h2>Histórico de entradas</h2>
          <p>Pagamentos registrados no período selecionado.</p>
        </div>
      </div>

      <div className="table-scroll">
        <table className="fc-table">
          <thead>
            <tr>
              <th>Data</th>
              <th>OS</th>
              <th>Cliente</th>
              <th>Ótica</th>
              <th>Método</th>
              <th>Status</th>
              <th className="right">Valor</th>
            </tr>
          </thead>

          <tbody>
            {lista.length ? (
              lista.map((item) => (
                <tr key={item.id} onClick={() => onOpenOS(item.osId)} className={item.osId ? 'clickable' : ''}>
                  <td>{formatDateLocal(item.data)}</td>
                  <td className="link-cell">#{item.os || '—'}</td>
                  <td>{item.cliente}</td>
                  <td>{item.loja}</td>
                  <td>
                    <MetodoBadge metodo={item.metodo} />
                    {item.parcelas > 1 ? <span className="parcelas">{item.parcelas}x</span> : null}
                  </td>
                  <td>{item.status || '—'}</td>
                  <td className="right value-green">{formatCurrency(item.valor)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="center">Nenhuma entrada encontrada.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}

function AReceberTable({ lista, onOpenOS }) {
  return (
    <section className="table-panel">
      <div className="panel-head">
        <div>
          <h2>Contas a receber</h2>
          <p>OS com saldo pendente dentro do período selecionado.</p>
        </div>
      </div>

      <div className="table-scroll">
        <table className="fc-table">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Contato</th>
              <th>OS</th>
              <th>Ótica</th>
              <th>Data</th>
              <th className="right">Total</th>
              <th className="right">Pago</th>
              <th className="right">Falta</th>
            </tr>
          </thead>

          <tbody>
            {lista.length ? (
              lista.map((item) => (
                <tr key={item.id} onClick={() => onOpenOS(item.id)} className={item.id ? 'clickable' : ''}>
                  <td className="strong">{item.cliente}</td>
                  <td>{item.contato}</td>
                  <td className="link-cell">#{item.os || '—'}</td>
                  <td>{item.loja}</td>
                  <td>{formatDateLocal(item.data)}</td>
                  <td className="right">{formatCurrency(item.valorTotal)}</td>
                  <td className="right value-green">{formatCurrency(item.valorPago)}</td>
                  <td className="right value-red">{formatCurrency(item.valorPendente)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="center">Nenhum cliente pendente no período.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}

/* =============================================================
   CSS
============================================================= */

function GlobalStyles() {
  return (
    <style>{`
      :root {
        --fc-bg: #f8fafd;
        --fc-surface: #ffffff;
        --fc-surface-2: #f1f3f4;
        --fc-text: #202124;
        --fc-muted: #5f6368;
        --fc-soft: #80868b;
        --fc-border: #dadce0;
        --fc-border-soft: #edf0f3;
        --fc-blue: #1a73e8;
        --fc-green: #188038;
        --fc-red: #d93025;
        --fc-orange: #b06000;
        --fc-font: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Inter, Arial, sans-serif;
      }

      * { box-sizing: border-box; }
      
      .fc-page {
        min-height: 100vh;
        padding: 18px;
        color: var(--fc-text);
        background: var(--fc-bg);
        font-family: var(--fc-font);
        -webkit-font-smoothing: antialiased;
        text-rendering: geometricPrecision;
      }

      .fc-top {
        margin-bottom: 12px;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        gap: 14px;
      }

      .fc-top-left {
        display: flex;
        align-items: flex-start;
        gap: 10px;
      }

      .kicker {
        display: block;
        margin-bottom: 2px;
        color: var(--fc-muted);
        font-size: 11px;
        font-weight: 700;
        letter-spacing: .04em;
        text-transform: uppercase;
      }

      .fc-top h1 {
        margin: 0;
        color: var(--fc-text);
        font-size: 26px;
        line-height: 1.1;
        font-weight: 650;
        letter-spacing: -.035em;
      }

      .fc-top p {
        margin: 4px 0 0;
        color: var(--fc-muted);
        font-size: 13px;
      }

      .fc-actions {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .plain-btn,
      .plain-icon-btn {
        height: 34px;
        border: 1px solid var(--fc-border);
        border-radius: 999px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        color: var(--fc-muted);
        background: #fff;
        font-size: 12px;
        font-weight: 650;
        font-family: inherit;
        cursor: pointer;
      }

      .plain-btn { padding: 0 11px; }
      .plain-icon-btn { width: 34px; padding: 0; flex-shrink: 0; }

      .plain-btn:hover,
      .plain-icon-btn:hover {
        color: var(--fc-text);
        background: var(--fc-surface-2);
      }

      .filter-shell {
        margin-bottom: 10px;
        padding: 9px;
        border: 1px solid var(--fc-border);
        border-radius: 13px;
        display: grid;
        grid-template-columns: minmax(230px, 1fr) minmax(170px, 220px) minmax(140px, 170px) minmax(140px, 180px) 138px 138px auto auto;
        gap: 8px;
        background: #fff;
      }

      .search-box {
        height: 34px;
        padding: 0 10px;
        border: 1px solid var(--fc-border);
        border-radius: 999px;
        display: flex;
        align-items: center;
        gap: 8px;
        color: var(--fc-muted);
        background: #fff;
      }

      .search-box input {
        width: 100%;
        border: 0;
        outline: 0;
        color: var(--fc-text);
        background: transparent;
        font-size: 12.5px;
        font-family: inherit;
      }

      .filter-shell select,
      .filter-shell > input {
        height: 34px;
        padding: 0 10px;
        border: 1px solid var(--fc-border);
        border-radius: 999px;
        outline: 0;
        color: var(--fc-text);
        background: #fff;
        font-size: 12px;
        font-family: inherit;
      }

      .search-box:focus-within,
      .filter-shell select:focus,
      .filter-shell > input:focus {
        border-color: var(--fc-blue);
        box-shadow: 0 0 0 3px rgba(26, 115, 232, .10);
      }

      .month-btn { white-space: nowrap; }

      .kpi-strip {
        margin-bottom: 10px;
        border: 1px solid var(--fc-border);
        border-radius: 13px;
        display: grid;
        grid-template-columns: repeat(5, minmax(0, 1fr));
        overflow: hidden;
        background: #fff;
      }

      .kpi-cell {
        min-height: 82px;
        padding: 12px;
        border-right: 1px solid var(--fc-border-soft);
        display: grid;
        grid-template-columns: 28px 1fr;
        grid-template-rows: auto auto auto;
        column-gap: 8px;
        align-content: center;
        background: #fff;
      }

      .kpi-cell:last-child { border-right: 0; }

      .kpi-icon {
        grid-row: 1 / span 3;
        width: 28px;
        height: 28px;
        border: 1px solid var(--fc-border);
        border-radius: 9px;
        display: grid;
        place-items: center;
        color: var(--fc-blue);
        background: #f8fafd;
      }

      .kpi-cell.green .kpi-icon { color: var(--fc-green); background: #f1f8f4; border-color: #cce8d5; }
      .kpi-cell.orange .kpi-icon { color: var(--fc-orange); background: #fff7ed; border-color: #fed7aa; }
      .kpi-cell.blue .kpi-icon { color: var(--fc-blue); background: #eef5ff; border-color: #d2e3fc; }

      .kpi-cell span {
        color: var(--fc-muted);
        font-size: 11px;
        font-weight: 700;
        letter-spacing: .02em;
        text-transform: uppercase;
      }

      .kpi-cell strong {
        margin-top: 3px;
        color: var(--fc-text);
        font-size: 18px;
        line-height: 1.15;
        font-weight: 700;
        letter-spacing: -.025em;
      }

      .kpi-cell small {
        margin-top: 3px;
        color: var(--fc-soft);
        font-size: 11px;
        font-weight: 500;
      }

      .tabs-line {
        margin-bottom: 10px;
        min-height: 42px;
        border: 1px solid var(--fc-border);
        border-radius: 13px;
        display: flex;
        align-items: stretch;
        overflow: hidden;
        background: #fff;
      }

      .tab-clean {
        min-width: 138px;
        padding: 0 13px;
        border: 0;
        border-right: 1px solid var(--fc-border-soft);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 7px;
        color: var(--fc-muted);
        background: #fff;
        font-size: 12.5px;
        font-weight: 700;
        font-family: inherit;
        cursor: pointer;
      }

      .tab-clean:last-child { border-right: 0; }

      .tab-clean:hover { color: var(--fc-text); background: #fbfcfe; }

      .tab-clean.active {
        color: var(--fc-blue);
        background: #f8fbff;
        box-shadow: inset 0 -2px 0 var(--fc-blue);
      }

      .tab-clean i {
        min-width: 20px;
        height: 20px;
        padding: 0 6px;
        border-radius: 999px;
        display: inline-grid;
        place-items: center;
        color: var(--fc-muted);
        background: #f1f3f4;
        font-size: 10.5px;
        font-style: normal;
        font-weight: 750;
      }

      .summary-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
      }

      .flat-panel,
      .table-panel {
        border: 1px solid var(--fc-border);
        border-radius: 13px;
        overflow: hidden;
        background: #fff;
      }

      .flat-panel.full { grid-column: 1 / -1; }

      .panel-head {
        min-height: 54px;
        padding: 12px;
        border-bottom: 1px solid var(--fc-border-soft);
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
      }

      .panel-head h2 { margin: 0; color: var(--fc-text); font-size: 14px; font-weight: 750; letter-spacing: -.01em; }
      .panel-head p { margin: 3px 0 0; color: var(--fc-muted); font-size: 11.5px; }

      .bar-list { padding: 12px; display: grid; gap: 12px; }
      .mini-bar-row { display: grid; gap: 6px; }

      .mini-bar-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
      }

      .mini-bar-top span {
        min-width: 0;
        overflow: hidden;
        color: var(--fc-muted);
        font-size: 12px;
        font-weight: 650;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .mini-bar-top strong { color: var(--fc-text); font-size: 12px; font-weight: 750; }

      .mini-bar-track { height: 5px; border-radius: 999px; overflow: hidden; background: #edf0f3; }
      .mini-bar-track i { display: block; height: 100%; border-radius: inherit; }

      .read-grid {
        padding: 12px;
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 8px;
      }

      .read-grid div {
        min-height: 66px;
        padding: 10px;
        border: 1px solid var(--fc-border-soft);
        border-radius: 11px;
        display: grid;
        align-content: center;
        gap: 4px;
        background: #fff;
      }

      .read-grid span { color: var(--fc-muted); font-size: 11px; font-weight: 650; }
      .read-grid strong { color: var(--fc-text); font-size: 17px; font-weight: 750; }

      .table-scroll { max-height: calc(100vh - 306px); overflow: auto; }
      .table-scroll::-webkit-scrollbar { width: 7px; height: 7px; }
      .table-scroll::-webkit-scrollbar-thumb { border-radius: 999px; background: rgba(95, 99, 104, .28); }

      .fc-table { width: 100%; min-width: 880px; border-collapse: collapse; }

      .fc-table th {
        position: sticky;
        top: 0;
        z-index: 2;
        height: 38px;
        padding: 0 12px;
        border-bottom: 1px solid var(--fc-border);
        color: var(--fc-muted);
        background: #f8fafd;
        font-size: 10.5px;
        font-weight: 750;
        letter-spacing: .04em;
        text-align: left;
        text-transform: uppercase;
        white-space: nowrap;
      }

      .fc-table td {
        height: 46px;
        padding: 0 12px;
        border-bottom: 1px solid var(--fc-border-soft);
        color: var(--fc-text);
        background: #fff;
        font-size: 12.5px;
        vertical-align: middle;
        white-space: nowrap;
      }

      .fc-table tr.clickable { cursor: pointer; }
      .fc-table tr.clickable:hover td { background: #f8fbff; }

      .fc-table .right { text-align: right; }
      .fc-table .center { height: 120px; color: var(--fc-muted); text-align: center; }

      .strong { font-weight: 700; }
      .link-cell { color: var(--fc-blue) !important; font-weight: 750; }
      .value-green { color: var(--fc-green) !important; font-weight: 750; }
      .value-red { color: var(--fc-red) !important; font-weight: 750; }

      .metodo-badge {
        padding: 3px 7px;
        border: 1px solid var(--metodo-border);
        border-radius: 999px;
        color: var(--metodo-color);
        background: var(--metodo-bg);
        font-size: 10.5px;
        font-weight: 750;
        text-transform: uppercase;
      }

      .parcelas { margin-left: 5px; color: var(--fc-muted); font-size: 11px; font-weight: 650; }

      .empty-state,
      .fc-loading {
        min-height: 260px;
        padding: 24px;
        display: grid;
        place-items: center;
        align-content: center;
        gap: 9px;
        color: var(--fc-muted);
        font-size: 13px;
        text-align: center;
      }

      .thin-loader {
        width: 190px;
        height: 3px;
        border-radius: 999px;
        overflow: hidden;
        background: #e8eaed;
        position: relative;
      }

      .thin-loader::after {
        content: "";
        position: absolute;
        inset: 0;
        width: 40%;
        border-radius: inherit;
        background: var(--fc-blue);
        animation: loader-move 1.1s linear infinite;
      }

      @keyframes loader-move {
        0% { transform: translateX(-100%); }
        100% { transform: translateX(260%); }
      }

      @media (max-width: 1180px) {
        .filter-shell { grid-template-columns: 1fr 1fr 1fr; }
        .kpi-strip { grid-template-columns: repeat(3, minmax(0, 1fr)); }
        .summary-grid { grid-template-columns: 1fr; }
        .flat-panel.full { grid-column: auto; }
      }

      @media (max-width: 760px) {
        .fc-page { padding: 10px; }
        .fc-top { align-items: stretch; flex-direction: column; }
        .fc-top-left { flex-direction: column; gap: 8px; }
        .filter-shell { grid-template-columns: 1fr; }
        .kpi-strip { grid-template-columns: 1fr; }
        .kpi-cell { border-right: 0; border-bottom: 1px solid var(--fc-border-soft); }
        .kpi-cell:last-child { border-bottom: 0; }
        .tabs-line { overflow-x: auto; }
        .tab-clean { flex: 0 0 auto; }
        .read-grid { grid-template-columns: 1fr 1fr; }
        .table-scroll { max-height: none; }
      }
    `}</style>
  );
}